import { SSOProviderConfig } from "./models";
import apiClient from "services/ApiClient";

/**
 * Test SSO connection by initiating an authentication flow in a new window
 */
export const testSSOConnection = async (ssoProvider: SSOProviderConfig): Promise<void> => {
  // Get the proper SSO test URL from the backend
  const response = await apiClient.get<{ testUrl: string }>("/api/sso-provider/test-url");
  const testUrl = response.testUrl;

  // Open in a new window for testing
  const width = 600;
  const height = 700;
  const left = screen.width / 2 - width / 2;
  const top = screen.height / 2 - height / 2;

  window.open(
    testUrl,
    "SSO Test",
    `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no`,
  );
};

/**
 * Format provider name for display
 */
export const formatProviderName = (provider: string): string => {
  const names: Record<string, string> = {
    okta: "Okta",
    azure_ad: "Azure AD",
    google_workspace: "Google Workspace",
    onelogin: "OneLogin",
  };

  return names[provider] || provider;
};

/**
 * Format protocol name for display
 */
export const formatProtocolName = (protocol: string): string => {
  const names: Record<string, string> = {
    saml: "SAML 2.0",
    oidc: "OpenID Connect",
  };

  return names[protocol] || protocol;
};
